<script>
  import moment from 'moment'
  export default{
    props: ['usuario', 'currentUser'],
    name: 'chat-usuario-item',
    data () {
      return {}
    },
    computed: {
      isCurrentUser () {
        if (this.currentUser.id === this.usuario.id) {
          return true
        }
        return false
      },
      nomeChat () {
        if (this.isCurrentUser) {
          return 'Você'
        }
        let semNome = 'Sem nome'
        if (typeof this.usuario.nome === 'undefined') { return semNome }
        let nome = this.usuario.nome
        if (nome === null) { return semNome }
        let nomeExp = nome.split(' ')
        if (nomeExp.length < 2) {
          return nomeExp[0]
        }
        let nomeFinal = nomeExp[0] + (typeof nomeExp[nomeExp.length - 1] !== 'undefined' ? ' ' + nomeExp[nomeExp.length - 1] : '')
        return nomeFinal
      },
      ultimoAcesso () {
        return this.usuario.ultimoAcesso ? moment(this.usuario.ultimoAcesso.date).fromNow() : null
      }
    },
    mounted () {},
    destroyed () {},
    methods: {},
    components: {}
  }
  // TODO: Criar opção de Online (Ajuste no Controller)
</script>

<template>
  <div class="chat-usuario-item">
    <div class="imagem u-img-rounded">
      <img width="20" :src="usuario.image" :alt="usuario.nome">
    </div>
    <div class="nome" :class="{'font-bold': isCurrentUser || usuario.naoLidas > 0}">
      <span v-if="usuario.naoLidas > 0" class="badge badge-sm bg-danger pull-right-xs">{{ usuario.naoLidas }}</span> {{ nomeChat }}
    </div>
    <div class="time">
      {{ ultimoAcesso }}
    </div>
  </div>
</template>

<style lang="scss">
  .chat-usuario-item {
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: #333333;
    white-space: nowrap;
    .imagem {
      flex: 0 0 20px;
    }
    .nome {
      padding-left: 10px;
      flex: 1;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
    }
    .time {
      flex: 0;
      font-size: 11px;
      color: #999999;
      white-space: nowrap;
    }
    &:hover {
      background-color: #f2f2f2;
    }
  }
</style>



// WEBPACK FOOTER //
// ChatUsuarioItem.vue?3eb1a375